'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Root } from '@radix-ui/react-avatar';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const Avatar = forwardRef(({ className, ...props }, ref) => (_jsx(Root, { ref: ref, className: cn('relative flex size-10 shrink-0 overflow-hidden rounded-full', className), ...props })));
Avatar.displayName = Root.displayName;
export { Avatar };
